import { createContext, useContext } from 'react';
import type { DashboardContextValue } from './dashboardTypes';

export const DashboardContext = createContext<DashboardContextValue | undefined>(undefined);

export function useDashboardData(): DashboardContextValue {
  const value = useContext(DashboardContext);
  if (!value) {
    throw new Error('useDashboardData must be used within a DashboardProvider');
  }
  return value;
}